import { createSlice } from '../../../../utils/@reduxjs/toolkit'
import { useInjectReducer } from '../../../../utils/redux-injectors'
import { ILoginFormComponent } from './types'
import { useInjectSaga } from 'redux-injectors'
import { loginFormComponentSaga } from './saga'

export const initialState: ILoginFormComponent = {
  email: '',
  password: '',
  loginFormAsyncError: null,
  isLoading: false,
  auth: null
}

const slice = createSlice({
  name: 'loginFormComponent',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setLogin(state, action) {
      state.isLoading = true
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload
    },
    setLoginFormAsyncError(state, action) {
      state.loginFormAsyncError = action.payload
    },
    setAuth(state, action) {
      if (!state.auth) {
        state.auth = {}
      }
      if (state.auth) {
        state.auth.accessToken = action.payload.accessToken
        state.auth.expires = action.payload.expires
        state.auth.refreshToken = action.payload.refreshToken
        state.auth.timestamp = action.payload.timestamp
      }
    }
  }
})

export const { actions: loginFormComponentActions, reducer } = slice

export const useLoginFormComponentSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer })
  useInjectSaga({ key: slice.name, saga: loginFormComponentSaga })
  return { actions: slice.actions }
}
